module.exports = __webpack_public_path__ + "img/KR.94941e04.svg";